<mat-drawer-container>
    <mat-drawer-content>
        <!-- PJH - 5/29/2024 - restoring the original way of displaying history for Rich Text Fields -->
        <div class="history-grid" *ngIf="showHistoryForRichTextField">
            <app-list-view *ngIf="!Comparing && ColumnsConfig"
                           [list]="ListItems"
                           [viewOverride]="'grid'"
                           [title]="Title"
                           [listType]="ListType"
                           [columnsConfig]="ColumnsConfig"
                           [defaultSortColumn]="'modifiedDate'"
                           [buttonConfig]="ButtonConfig"
                           [hasCheckboxes]="true"
                           [maxSelection]="2"
                           (exceededMaxSelection)="handleExceededMaxSelection()"
                           (editClick)="this.displayEntity($event)"
                           (buttonClick)="this.doOnButtonClick($event)"
                           (itemActionClick)="this.doOnItemAction($event)"
                           (itemContextMenu)="this.doOnItemContextMenu($event)"
                           [enableInfiniteScrolling]="true"
                           (loadMore)="this.handleLoadMore($event)"
                           (selectionsSet)="setSelectedVersions($event)">
            </app-list-view>

            <div style="visibility: hidden; position: fixed"
                 [style.left]="this.ItemContextMenuPositionX"
                 [style.top]="this.ItemContextMenuPositionY"
                 [matMenuTriggerFor]="itemContextMenu"
                 #itemContextMenuTrigger>
            </div>
            <mat-menu #itemContextMenu="matMenu">
                <button mat-menu-item
                        [disabled]="TwoVersionsSelected"
                        (click)="this.doOnRestore($event)">
                    Restore this Version
                </button>
                <button mat-menu-item
                        [disabled]="!TwoVersionsSelected"
                        (click)="this.doOnCompare($event)">
                    Compare Selected
                </button>
                <button mat-menu-item
                        [disabled]="TwoVersionsSelected"
                        (click)="this.doOnViewVersion($event)">
                    View this Version
                </button>
            </mat-menu>

            <div *ngIf="Comparing" class="compare">
                <mat-toolbar class="short-toolbar">
                    <div>Comparing {{VersionOneForCompare.name}} and {{VersionTwoForCompare.name}}</div>
                    <span class="toolbar-spacer"></span>
                    <button class="button-primary" mat-button (click)="Comparing = false">Close Compare</button>
                </mat-toolbar>
                <ng-container *ngIf="DiffReady">
                    <div class="column" [innerHtml]="DiffHtml | safe: 'html'"></div>
                </ng-container>
                <div *ngIf="!DiffReady">Loading...</div>
            </div>

            <div class="transition-history">
                <app-list-view *ngIf="!Comparing && ShowTransitionHistory && LogMessages?.length > 0"
                               [list]="LogMessages"
                               [viewOverride]="'grid'"
                               [title]="'Workflow Transition History'"
                               [columnsConfig]="['description', 'modifiedBy', 'modifiedDate']"
                               [defaultSortColumn]="'createdDate'">
                </app-list-view>
            </div>
        </div>

        <!-- For all other displays of History use the newer Kendo Grid based display that is backed by Dan Singer's Table Function -->
        <div class="history-grid" *ngIf="!showHistoryForRichTextField">
            <h2>History for {{formInstance.name}}</h2>

            <kendo-grid formInstanceHistoryRemoteBinding
                        (notifyLoaded)="Helper.handleLoaded($event)"
                        [height]="400"
                        [formInstanceId]="formInstance.id"
                        [selectable]="true"
                        [sortable]="true"
                        [filterable]="true"
                        [navigable]="true"
                        (cellClick)="Helper.setIndexOfClickedRow($event)"
                        [rowClass]="Helper.applyClickedRowClassToClickedRow"
                        [(filter)]="Helper.Filters">

                <ng-template kendoGridToolbarTemplate>
                    <kendo-grid-spacer></kendo-grid-spacer>
                    <ng-container *ngIf="Helper.IsBeingFiltered">
                        <button class="clear-all-filters-btn" mat-stroked-button (click)='Helper.handleClearFilters()'>
                            Clear All Filters
                        </button>
                        {{Helper.ShowingXofN}}
                    </ng-container>

                    <button class="toolbar-button button-primary" mat-raised-button color="primary" (click)="this.closeHistory()">
                        Close History
                    </button>
                </ng-template>

                <kendo-grid-column field="formFieldName" title="Field Name"></kendo-grid-column>
                <kendo-grid-column field="value" title="Value">
                    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <ng-container *ngIf="isGridElement(dataItem)">
                            <a class="download-link" (click)="downloadGridData(dataItem)">Download CSV</a>
                        </ng-container>
                        <ng-container *ngIf="!isGridElement(dataItem)">
                            {{dataItem.value}}
                        </ng-container>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="modifiedDate" title="Modified On" filter="date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.modifiedDate | date: 'MM/dd/yyyy h:mm:ss a'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="modifiedBy" title="Modified By"></kendo-grid-column>
                <!--
                <kendo-grid-command-column [width]="50">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button *ngIf="isGridElement(dataItem)" class="command-btn" kendoButton kendoGridFocusable (click)="downloadGridData(dataItem)"><mat-icon class="row-action-icon" title="Download Grid as CSV">download</mat-icon></button>
                    </ng-template>
                </kendo-grid-command-column>
                -->
            </kendo-grid>
        </div>

    </mat-drawer-content>

    <!-- The drawer for editing comments is only for FormInstanceElementVersions, not FormInstanceVersions -->
    <mat-drawer *ngIf="SelectedItem"
                [opened]="SelectedItem != null"
                mode="over"
                position="end"
                class="commentDrawer">
        <div *ngIf="!SelectedItem.isOriginalVersion" class="drawer-div">
            <div class="drawer-div">
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="comment-field">
                    <mat-label>Comment</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="SelectedItem.comment" maxlength="256">
                </mat-form-field>
            </div>
            <div class="comment-buttons">
                <button mat-raised-button type="button" color="primary" (click)="saveComment()">Save</button>
                <button mat-raised-button type="button" (click)="cancel()">Cancel</button>
            </div>
        </div>
        <div *ngIf="SelectedItem.isOriginalVersion" class="no-you-dont">
            <div class="comment-buttons">You can only comment on past versions of the original field.</div>
            <div class="comment-buttons">
                <button mat-raised-button type="button" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </mat-drawer>
</mat-drawer-container>
